import React from 'react';
import Header from "../../components/layout/Header";
import Banner from "../../components/home/Banner";
import Footer from "../../components/layout/Footer";

const Grocery = () => {
    const banners = [
        "/grocery_hero_banner.png",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/d34fc9b3a0429712.jpg?q=20",
        "https://rukminim1.flixcart.com/fk-p-flap/1600/350/image/62b6623631526487.jpg?q=20",
    ];

    return (
        <div style={{ backgroundColor: '#f8fdf8', minHeight: '100vh', paddingTop: '128px' }}>
            <Header />

            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '12px 16px' }}>

                {/* 1. Scrolling Hero Banner */}
                <div style={{ marginBottom: '32px', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <Banner images={banners} height="450px" />
                </div>

                {/* 2. Quick Access Categories */}
                <div style={{ backgroundColor: 'white', padding: '32px', borderRadius: '32px', marginBottom: '40px', boxShadow: '0 1px 2px rgba(0,0,0,0.06)' }}>
                    <div style={{ display: 'flex', gap: '48px', overflowX: 'auto', paddingBottom: '16px', justifyContent: 'center' }} className="no-scrollbar">
                        {[
                            { name: "Cooking Specials", img: "/cooking_cat.png", bg: "#e8f5e9" },
                            { name: "Dairy & Eggs", img: "/dairy_cat.png", bg: "#fff3e0" },
                            { name: "Snacks & Drinks", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/1d34c62dd9806e23.jpg?q=20", bg: "#e1f5fe" },
                            { name: "Home Needs", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/3b12ea642f89f924.jpg?q=20", bg: "#f3e5f5" },
                            { name: "Personal Care", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/091396a84c79435b.jpg?q=20", bg: "#fce4ec" }
                        ].map((cat, i) => (
                            <div key={i} style={{ minWidth: '130px', cursor: 'pointer', textAlign: 'center', transition: '0.3s', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ backgroundColor: cat.bg, borderRadius: '50%', padding: '24px', border: '2px solid white', boxShadow: '0 1px 2px rgba(0,0,0,0.06)', width: '128px', height: '128px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img src={cat.img} alt={cat.name} style={{ width: '80px', height: '80px', objectFit: 'contain' }} />
                                </div>
                                <p style={{ fontSize: '14px', fontWeight: '800', marginTop: '12px', color: '#2e7d32', margin: '12px 0 0 0' }}>{cat.name}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 3. Steal Deals - Product Grid */}
                <div style={{ marginBottom: '48px' }}>
                    <h2 style={{ fontSize: '26px', marginBottom: '32px', fontWeight: '900', color: '#1b5e20', textAlign: 'start' }}>Basket Best Sellers</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '32px' }}>
                        {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
                            <div key={i} style={{ textAlign: 'start', backgroundColor: 'white', padding: '24px', borderRadius: '28px', cursor: 'pointer', transition: '0.3s', border: '1px solid #e0e0e0', display: 'flex', flexDirection: 'column' }}>
                                <div style={{ width: '100%', height: '180px', marginBottom: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img src="https://rukminim2.flixcart.com/image/280/280/xif0q/edible-oil/v/e/u/-original-imahf4r9f9gzshge.jpeg?q=70" alt="Product" style={{ height: '100%', objectFit: 'contain', margin: '0 auto' }} />
                                </div>
                                <span style={{ backgroundColor: '#2f855a', color: 'white', borderRadius: '999px', padding: '2px 12px', width: 'fit-content', fontSize: '12px', marginBottom: '4px', fontWeight: '600' }}>Bestseller</span>
                                <p style={{ fontWeight: '700', fontSize: '16px', color: '#333', margin: '0 0 4px 0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>Fortune Soyabean Oil 1L</p>
                                <p style={{ color: '#718096', fontSize: '13px', fontWeight: '600', margin: 0 }}>Standard Pack | 1 kg</p>
                                <div style={{ marginTop: '12px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span style={{ fontWeight: '900', fontSize: '20px', color: '#2e7d32' }}>₹124</span>
                                        <span style={{ fontSize: '12px', color: '#a0aec0', textDecoration: 'line-through' }}>₹180</span>
                                    </div>
                                    <button style={{ backgroundColor: '#2e7d32', color: 'white', padding: '6px 20px', borderRadius: '999px', fontWeight: '800', fontSize: '14px', border: 'none', cursor: 'pointer', transition: '0.2s' }}>
                                        ADD
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Grocery;

